<template>
  <div>
    <el-card class="box-card" v-auth="'/log/pageList'">
      <el-form :model="searchForm">
        <el-row>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="ip" :label-width="formLabelWidth" prop="ip">
              <el-input
                v-model="searchForm.ip"
                placeholder="请输入ip"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="24" :lg="6">
            <el-form-item
              label="日志类型"
              :label-width="formLabelWidth"
              prop="type"
            >
              <el-select
                clearable
                v-model="searchForm.type"
                placeholder="请选择日志类型"
              >
                <el-option :key="0" :value="0" label="全部日志"></el-option>
                <el-option :key="1" :value="1" label="登录日志"></el-option>
                <el-option :key="2" :value="2" label="操作日志"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="24" :lg="6">
            <el-form-item
              label="时间"
              :label-width="formLabelWidth"
              prop="time"
            >
              <el-date-picker
                style="width: 100%"
                v-model="searchForm.time"
                format="yyyy-MM-dd"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6" style="text-align: right">
            <el-button type="primary" @click="pageList">查询</el-button>
            <el-button
              type="primary"
              @click="reset"
              icon="el-icon-refresh"
              v-auth="'/log/pageListreset'"
              >重置</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px">
      <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="width: 100%"
        height="520"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="url" label="url" width="300"></el-table-column>
        <el-table-column
          prop="params"
          label="请求参数"
          width="300"
        ></el-table-column>
        <el-table-column prop="ip" label="ip" width="200"></el-table-column>
        <el-table-column
          prop="agentName"
          label="机构"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="operator"
          label="操作人"
          width="200"
        ></el-table-column>
        <el-table-column prop="createTime" label="日期"></el-table-column>
      </el-table>
      <el-pagination
        background
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px; text-align: right"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "id",
        sortOrder: "desc"
      },
      loading: false,
      searchForm: {
        ip: "",
        type: 0,
        time: [],
        pageSize: "",
        pageNumber: "",
        sortName: "",
        sortOrder: "",
      },
      addForm: {
        username: "",
        password: "",
        role: [],
        roleList: []
      },
      editForm: {
        id: "",
        username: "",
        password: "",
        role: [],
        roleList: []
      },
      formLabelWidth: "80px",
      multipleSelection: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
    };
  },
  methods: {
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    selectionChange (val) {
      this.multipleSelection = val;
    },
    pageList () {
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize
      this.searchForm.pageNumber = this.page.pageNumber
      this.searchForm.sortName = this.page.sortName
      this.searchForm.sortOrder = this.page.sortOrder
      this.api.log.pageList(this.searchForm).then(result => {
        this.page.rows = result.data.records
        this.page.total = result.data.total
        this.loading = false
      }).catch(error => {
        console.log(error)
      })
    },
    reset () {
      this.searchForm.ip = "";
      this.searchForm.type = 0;
      this.searchForm.time = [];
      this.page.pageNumber = 1;
      this.page.pageSize = 10;
      this.pageList()
    }
  },
  watch: {},
  mounted () {
    this.pageList();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/log/index.vue